// extracted by mini-css-extract-plugin
export default {"wrapper":"classes_wrapper__+Ni8C","overlay":"classes_overlay__qyjT3"};